import { Box, useDisclosure } from '@chakra-ui/react'
import type { SubMenuProps } from './Menu'

export const MenuItemWithSubMenu = ({
  button,
  subMenu,
  trigger = 'mouse',
}: SubMenuProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  let props: object = {}
  if (trigger == 'mouse')
    props = { ...props, onMouseEnter: onOpen, onMouseLeave: onClose }

  if (trigger == 'click')
    props = { ...props, onClick: () => (isOpen ? onClose() : onOpen()) }

  return (
    <Box
      as="ul"
      sx={{
        gap: 1,
        position: 'relative',
        justifyContent: 'start',
        textAlign: 'start',
        listStyle: 'none',
      }}
      {...props}
    >
      {button && button}

      {subMenu && isOpen && subMenu}
    </Box>
  )
}